import { render, staticRenderFns } from "./Score_control.vue?vue&type=template&id=736db6d5&scoped=true"
import script from "./Score_control.vue?vue&type=script&lang=js"
export * from "./Score_control.vue?vue&type=script&lang=js"
import style0 from "./Score_control.vue?vue&type=style&index=0&id=736db6d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736db6d5",
  null
  
)

export default component.exports